// src/pages/Shop/ShopPage.jsx

import React, { useEffect, useState } from "react";
import api from "../../api/axiosClient";
import useProducts from "../../hooks/useProducts";
import { useCartContext } from "../../components/CartContext";
import ProductQuickView from "../../components/ProductQuickView";
import { useAuth } from "../../context/AuthContext";
import NoImage from "../../assets/NoImage.png";

/* GlassTile Component */
function GlassTile({ className = "", children }) {
  return (
    <div
      className={
        "bg-white/40 backdrop-blur-md border border-white/25 rounded-2xl shadow-md " +
        className
      }
      style={{ WebkitBackdropFilter: "blur(12px) saturate(140%)" }}
    >
      {children}
    </div>
  );
}

/* Product Card */
function ProductCard({ product, quantity, onAdd, onIncrement, onDecrement, onOpen }) {
  return (
    <div className="rounded-2xl overflow-hidden cursor-pointer" onClick={onOpen}>
      <GlassTile className="p-4 h-full flex flex-col">
        {/* <div className="w-full h-48 bg-gray-100 rounded-xl flex items-center justify-center mb-4">
          <img
            src={
              product.imageUrl ||
              `https://via.placeholder.com/320x200?text=${encodeURIComponent(
                product.displayName
              )}`
            }
            alt={product.displayName}
            className="object-contain max-h-44"
          />
        </div> */}
        <div className="bg-white rounded-xl shadow p-4">
          <img
            src={product.imageUrls?.[0] || NoImage}
            alt={product.name}
            loading="lazy"
            onError={(e) => {
              const target = e.currentTarget;
              target.onerror = null;
              target.src = NoImage;
            }}
            className="w-full h-64 object-cover rounded-xl mb-3"
          />

          <p className="font-medium text-center">
            {product.productName}
          </p>
        </div>

        <h3 className="text-lg font-semibold text-gray-800">{product.name}</h3>
      </GlassTile>
    </div>
  );
}


export default function ShopPage() {
  const { data: products = [], isLoading } = useProducts();
  const [categories, setCategories] = useState([]);
  const [activeCat, setActiveCat] = useState("All");
  const [activeProduct, setActiveProduct] = useState(null);
  const [variants, setVariants] = useState([]);
  const [popupQty, setPopupQty] = useState(1);
  const [selectedVariantId, setSelectedVariantId] = useState(null)
  const [images, setImages] = useState([])

  const { accessToken, user } = useAuth();
  const token = accessToken;
  const userId = user?.userId || user?.id;

  const { cart, addItem, updateQty, getQty, removeItem, totalItems } = useCartContext();



  /* Load categories dynamically */
  useEffect(() => {
    if (!products.length) return;

    const uniqueCats = [
      ...new Set(products.map((p) => p.category).filter(Boolean)),
    ];
    setCategories(["All", ...uniqueCats]);
  }, [products]);

  const filteredProducts =
    activeCat === "All"
      ? products
      : products.filter((p) => p.category === activeCat);

  /* ⭐ Add to Cart Logic */

  const handleAddToCart = (product) => {
    addItem(product);
  };

  const selectVariant = (variant) => {
    setSelectedVariantId(variant.id)
    setImages(variant.imageUrls || [])
  }
  /*const handleAddToCart = async (product) => {
    let localCart = JSON.parse(localStorage.getItem("cart")) || [];

    const existing = localCart.find((c) => c.productId === product.id);

    if (existing) {
      existing.quantity += 1;
    } else {
      localCart.push({
        productId: product.id,
        productName: product.name,
        price: product.price,
        quantity: 1,
        imageUrl: product.imageUrl,
        category: product.category,
      });
    }

    // Save local cart
    localStorage.setItem("cart", JSON.stringify(localCart));

    // If logged in → sync with backend
    if (token && userId) {
      try {
        await api.post(
          "/cart/add",
          {
            productId: product.id,
            quantity: 1,
          },
          { headers: { "X-User-Id": userId } }
        );
      } catch (err) {
        console.error("Failed to sync cart with backend:", err);
      }
    }
    console.log("Added to cart:", product);
    console.log("Current cart:", localCart);
    console.log("User id:", userId);
    alert(`${product.name} added to cart`);
  };
  */
  return (
    <div
    // className="min-h-screen overflow-y-auto"
    >
      <main className="max-w-7xl mx-auto px-6 pt-28 pb-20">

        {/* Offers */}
        <section className="mb-8">
          <GlassTile className="p-6">
            <h2 className="text-2xl font-bold text-gray-800">
              Exclusive Offers & Perks
            </h2>
            <p className="text-gray-700 mt-1">
              Free shipping + Exclusive deals available now
            </p>
          </GlassTile>
        </section>

        {/* Categories */}
        <div className="mb-6 flex flex-wrap gap-3 justify-center">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCat(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition ${cat === activeCat
                ? "bg-blue-600 text-white shadow"
                : "bg-white/70 text-gray-800 hover:bg-white/90"
                }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Products */}
        {isLoading ? (
          <div className="text-center py-12 text-gray-600">Loading…</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredProducts.map((product) => (
              console.log(product),
              <ProductCard
                key={product.id}
                product={product}
                // quantity={getQty(product.id)}
                // onAdd={handleAddToCart}
                // onIncrement={() => updateQty(product.id, getQty(product.id) + 1)}
                // onDecrement={() => updateQty(product.id, getQty(product.id) - 1)}
                onOpen={async () => {
                  setActiveProduct(product);
                  setPopupQty(1);

                  const res = await fetch(`/api/product/${product.id}/variants`);
                  const data = await res.json();

                  setVariants(data);

                  if (data.length > 0) {
                    setSelectedVariantId(data[0].id);
                    setImages(data[0].imageUrls || []);
                  }
                }}

              />

            ))}

          </div>
        )}
      </main>
      {activeProduct && (
        <ProductQuickView
          product={activeProduct}
          variants={variants}
          images={images}
          selectedVariantId={selectedVariantId}
          onVariantSelect={selectVariant}
          quantity={popupQty}
          onClose={() => setActiveProduct(null)}
          onInc={() => setPopupQty(q => q + 1)}
          onDec={() => setPopupQty(q => (q > 1 ? q - 1 : 1))}
          onAdd={handleAddToCart}
        />

      )}

      {/* ── FOOTER ── */}
      <footer className="mt-40 mb-6 px-6">
        <GlassTile className="text-center text-gray-700 text-sm py-4">
          © 2025 5Buddies — Designed for creators, dreamers & rebels.
          <div className="mt-2 space-x-4">
            <a href="#" className="hover:text-blue-700">Privacy</a>
            <a href="#" className="hover:text-blue-700">Terms</a>
            <a href="#" className="hover:text-blue-700">Contact</a>
          </div>
        </GlassTile>
      </footer>
    </div>
  );
}
